import { defineMessages } from 'react-intl';

export const estimationItemsTableMessageDefinitions = defineMessages({
  estimate: {
    id: 'estimationDetail.estimationItemsDirectCostSummaryTable.estimate',
    defaultMessage: 'Estimate',
  },
  subtotal: {
    id: 'estimationDetail.estimationItemsDirectCostSummaryTable.subtotal',
    defaultMessage: 'Subtotal',
  },
});
